import React from 'react';
import PropTypes from 'prop-types';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

import GoodOptionDropdown from '@fo-pages/good/summary/option/GoodOptionDropdown';

const GoodOptionItemList = ({
  floatingType,
  itemNodeList,
  onSelect,
  handleSelectOptionContainerHeight,
  optionLabelList,
  styleProps,
}) => (
  <FlexBoxColumn gap={'10px'} width={'100%'}>
    <GoodOptionDropdown
      floatingType={floatingType}
      itemNodeList={itemNodeList}
      onSelect={onSelect}
      handleSelectOptionContainerHeight={handleSelectOptionContainerHeight}
      optionLabelList={optionLabelList}
      styleProps={styleProps}
    />
  </FlexBoxColumn>
);

GoodOptionItemList.propTypes = {
  floatingType: PropTypes.bool,
  itemNodeList: PropTypes.array,
  onSelect: PropTypes.func,
  handleSelectOptionContainerHeight: PropTypes.func,
  optionLabelList: PropTypes.array,
  styleProps: PropTypes.object,
};

export default GoodOptionItemList;
